import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { money } from "@/lib/money";

const Stat = ({ label, value, sub, testid, tone }) => (
  <div className="p-4 sm:p-5 border-r border-b border-[#262626] min-w-0" data-testid={testid}>
    <div className="font-mono-label text-[10px] text-muted-foreground">{label}</div>
    <div className={`font-heading font-black text-2xl sm:text-3xl mt-1 truncate ${tone || ""}`}>{value}</div>
    {sub && <div className="text-[11px] text-muted-foreground mt-1">{sub}</div>}
  </div>
);

export default function RevenueSummary({ data, compact }) {
  if (!data) return null;
  const s = data.summary;
  return (
    <section className={compact ? "mb-8" : "mb-8"} data-testid="revenue-summary">
      {compact && (
        <div className="flex items-center justify-between mb-2">
          <div className="font-mono-label text-[10px] text-muted-foreground">REVENUE · LIVE FROM STRIPE</div>
          <Link to="/admin/revenue" data-testid="revenue-open-link" className="font-mono-label text-[11px] text-[#FFD600] inline-flex items-center gap-1 hover:underline">
            Full revenue report <ArrowRight size={12} />
          </Link>
        </div>
      )}
      <div className="grid grid-cols-2 lg:grid-cols-4 border-l border-t border-[#262626]">
        <Stat testid="revenue-mrr" label="MONTHLY RECURRING" value={money(s.mrr_cents)} sub={`${s.active_subscriptions} active subscription${s.active_subscriptions === 1 ? "" : "s"}`} tone="text-[#FFD600]" />
        <Stat testid="revenue-cash-net" label="CASH THIS MONTH (NET)" value={money(s.cash_net_cents)} sub={`${money(s.cash_gross_cents)} collected · ${money(s.cash_refunds_cents)} refunded`} tone="text-[#4ADE80]" />
        <Stat testid="revenue-discounts" label="DISCOUNTS THIS MONTH" value={money(s.discounts_cents)} sub={`${money(s.discounts_12mo_cents)} in last 12 months`} />
        <Stat testid="revenue-cancellations" label="CANCELLATIONS" value={s.cancelled_this_month} sub={`this month · ${s.canceling} ending at period end`} tone={s.cancelled_this_month ? "text-[#F87171]" : ""} />
        {!compact && (
          <>
            <Stat testid="revenue-paying" label="PAYING CLIENTS" value={`${s.paying_clients} / ${s.total_clients}`} />
            <Stat testid="revenue-net-12mo" label="NET LAST 12 MONTHS" value={money(s.net_12mo_cents)} />
            <Stat testid="revenue-refunds-12mo" label="REFUNDS LAST 12 MONTHS" value={money(s.refunds_12mo_cents)} tone={s.refunds_12mo_cents ? "text-[#F87171]" : ""} />
            <Stat testid="revenue-arr" label="ANNUAL RUN RATE" value={money(s.mrr_cents * 12, 0)} sub="monthly recurring × 12" />
          </>
        )}
      </div>
    </section>
  );
}
